<loader [show]="isLoading"></loader>
<button class="btn btn-complete btn-map btn-append ms-2" [disabled]="!canOpen" (click)="openMap()"></button>